module.exports = __webpack_public_path__ + "img/icon-youyou-left.d5dc199c.png";